// extracted by mini-css-extract-plugin
export default {"fullscreen":"style_fullscreen__EHPVk","energyGraphContainer":"style_energyGraphContainer__8D-WG","energyGraph":"style_energyGraph__VJrZd","radioMenu":"style_radioMenu__IyJ1L"};